import React, {useEffect} from 'react'
import {withUpdaters} from '@containers/updaters'
import {SyncUpdater} from '@containers/updaters/sync-updater'
import {useStore} from './subtasks-store'

export const SyncState = React.memo(
  withUpdaters(
    SyncUpdater({filter: '*', debounceTime: 100, companyType: 'current'})
  )(() => {
    const [, store] = useStore()
    useEffect(() => store.syncState())
    return null
  })
)
